<header class="topnav">
  <div class="topnav-inner">
    <!-- Brand zone -->
    <div class="topnav-brand-zone">
      <a routerLink="/home" class="brand-link" aria-label="Go to home">
        <span class="brand-logo-col">
          @if (companyLogoUrl()) {
            <img
              [src]="companyLogoUrl()"
              class="brand-logo"
              height="28"
              width="28"
              [alt]="(companyInfo()?.companyName || 'ZelusHR') + ' logo'"
            />
          } @else {
            <img
              src="assets/logo/zelustech-logo-only-cream-orange.svg"
              class="brand-logo"
              height="28"
              width="28"
              alt="ZelusHR logo"
            />
          }
        </span>
        <span class="company-title">
          {{ companyInfo()?.companyName || 'ZelusHR' }}
        </span>
      </a>
    </div>

    <!-- Main zone: flex-grow, holds actions -->
    <div class="topnav-main-zone">
      <div class="topnav-actions">
        @if (profileInfo()) {
          <button
            type="button"
            class="account-trigger"
            (click)="menu.toggle($event)"
            aria-haspopup="menu"
            [attr.aria-label]="
              'Open account menu for ' +
              (profileInfo()?.firstName | titlecase) +
              ' ' +
              (profileInfo()?.lastName | titlecase)
            "
          >
            <span class="account-avatar" aria-hidden="true">
              <lucide-icon [img]="icons.user" [size]="16"></lucide-icon>
            </span>
            <span class="account-name">
              {{ profileInfo()?.firstName | titlecase }} {{ profileInfo()?.lastName | titlecase }}
            </span>
            <lucide-icon
              [img]="icons.chevronDown"
              [size]="14"
              class="account-chevron"
              aria-hidden="true"
            ></lucide-icon>
          </button>
          <app-action-menu #menu [items]="items"></app-action-menu>
        } @else {
          <button type="button" class="zh-btn-accent login-btn" routerLink="/login">Login</button>
        }
      </div>
    </div>
  </div>
</header>
